import moment from 'jalali-moment'
import { longJalali } from 'utilities/helper/format'

/** A Gregorian `YYYY-MM-DD` as «۱ فروردین ۱۴۰۴». */
export const gregorianToLong = (gregorian: string) =>
    longJalali(
        moment(gregorian, 'YYYY-MM-DD').locale('fa').format('YYYY-MM-DD')
    )

/**
 * «امتیاز از … حساب شده» — under a rank on a screen that follows the
 * «امتیاز از» filter without showing it (کارنامهٔ عضو, a request's detail,
 * the dashboard card). The filter is chosen on the list and carried into
 * the member's page so the two ranks agree; without this line the page
 * would show a rank that silently is not the whole-history one.
 *
 * Reads the window from the payload, not from the filter: it states what
 * the numbers beside it were counted over. Nothing when that is the whole
 * history.
 */
export default function ScoreFromNote({
    appliedFrom,
    className = ' mt-1.5',
}: {
    appliedFrom?: TScoreFrom
    className?: string
}) {
    if (!appliedFrom) return null
    return (
        <p className={`${className} text-[11px] text-text-secondary`}>
            امتیاز از{' '}
            <b className=" text-text-body">{gregorianToLong(appliedFrom)}</b>{' '}
            حساب شده
        </p>
    )
}
